import dayjs from 'dayjs'
import ruLocale from 'dayjs/locale/ru'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import weekday from 'dayjs/plugin/weekday'

dayjs.locale(ruLocale)
dayjs.extend(weekday)
dayjs.extend(customParseFormat)